



import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import { Node as ProsemirrorNode } from 'prosemirror-model';
import { IField, IMergeValues } from '@/editor/types';
import { EFieldType, EMergeCategory, EMergeKey } from '@/editor/types/enums';
import { IRecipient } from '@lib-shared/types/Recipient';
import { IDocumentValues } from '@/editor/types/merge-values';
import { IUser } from '@/types/User';
import { IEntity } from '@/types/Entity';

@Component
export default class MergeValueView extends Vue {
  @Prop() node: ProsemirrorNode;
  @Prop() options: {
    mergeValues: IMergeValues;
    fields: IField[];
  };

  get tagId(): string {
    return this.node.attrs.tagId;
  }

  get field(): IField {
    return this.options?.fields?.find(({ id }: IField) => id === this.tagId);
  }

  get documentValues(): IDocumentValues {
    return this.options?.mergeValues?.document;
  }

  get sender(): IUser {
    return this.options?.mergeValues?.sender;
  }

  get entity(): IEntity {
    return this.options?.mergeValues?.entity as IEntity;
  }

  get recipient(): IRecipient {
    return this.options?.mergeValues?.recipients?.find(
      ({ id }: IRecipient) => this.recipientId === id
    );
  }

  get fieldType(): EFieldType {
    return this.field?.type;
  }

  get category(): EMergeCategory {
    return this.field?.category;
  }

  get mergeKey(): EMergeKey {
    return this.field?.mergeKey;
  }

  get recipientId(): string {
    return this.field?.recipientId;
  }

  get documentValue(): string {
    const value: string = this.documentValues?.[this.mergeKey];

    if (!value) {
      return '';
    }

    if (this.mergeKey === EMergeKey.sendDate || this.mergeKey === EMergeKey.expirationDate) {
      return moment(value).format('LLL');
    }

    return value;
  }

  get recipientValue(): string {
    if (!this.recipient || !this.recipient?.email) {
      return '';
    }

    return this.recipient?.[this.mergeKey] || '';
  }

  mergeValue(): string {
    if (this.fieldType === EFieldType.Custom) {
      return this.field.value || '';
    }

    switch (this.category) {
      case EMergeCategory.Recipient:
        return this.recipientValue;

      case EMergeCategory.Entity:
        return this.entity?.[this.mergeKey] || '';

      case EMergeCategory.Sender:
        return this.sender?.[this.mergeKey] || '';

      case EMergeCategory.Document:
        return this.documentValue;

      default:
        return '';
    }
  }
}
